// noinspection DuplicatedCode

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import Button from "@material-tailwind/react/Button";
import Modal from "@material-tailwind/react/Modal";
import ModalBody from "@material-tailwind/react/ModalBody";
import ModalFooter from "@material-tailwind/react/ModalFooter";
import ModalHeader from "@material-tailwind/react/ModalHeader";
import { toast } from "react-toastify";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import { isRequired, useForm } from "../../../../components/isRequired";
import { alertService } from "../../../../services/AlertService";

import { useMutation } from "@tanstack/react-query";
import TableCard from "../../../../components/tablecard/TableCard";

import { getMinKaryawan } from "../../karyawan/karyawanSlice";
import {
  pelatihanTransaksiSelector,
  updatePelatihanTransaksi,
} from "./pelatihanTransaksiSlice";

import NotificationContainer from "react-notifications/lib/NotificationContainer";
import { Colors } from "../../../../assets/Colors";
import { createNotification } from "../../../../components/notification/notification";
import { fetchPost, fetchPostSilance } from "../../../../fetchers";
import { KaryawanSelectorBuilder } from "../../karyawan/KaryawanSelector";

const PelatihanPage = ({}) => {
  let initialState = {
    Nik: "",
    TopikPelatihan: "",
    JenisPelatihan: -1,
    LembagaPelatihan: "",
    MateriPelatihan: "",
    TujuanPelatihan: "",
    TempatPelaksanaan: "",
    BiayaPelatihan: "",
    Tiket: 0,
  };

  const validations = [
    ({ Nik }) => isRequired(Nik) || { Nik: "NIK wajib diisi" },
  ];
  const mutation = useMutation((param) => fetchPost("getPelatihan", param));

  const mutationInput = useMutation((param) =>
    fetchPostSilance("insertPelatihan", param)
  );

  const {
    changed,
    values,
    isValid,
    errors,
    touched,
    changeHandler,
    editHandler,
    clearHandler,
    submitHandler,
    customHandler,
  } = useForm(initialState, validations);
  const [buttonTouched, setButtonTouched] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [TanggalPelaksanaan, setTanggalPelaksanaan] = useState("");
  const [TanggalSelesai, setTanggalSelesai] = useState("");
  const [isValidTanggalPelaksanaan, setIsValidTanggalPelaksanaan] =
    useState(true);
  const [isValidTanggalSelesai, setIsValidTanggalSelesai] = useState(true);
  const [dateChanged, setDateChanged] = useState(false);
  const [firstLoading, setFirstLoading] = useState(false);
  const [start, setStart] = useState(0);
  const [count, setCount] = useState(5);
  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(0);
  const [search, setSearch] = useState("");
  const [searchFetch, setSearchFetch] = useState(false);
  const [updateFetch, setUpdateFetch] = useState(false);

  const [insertFetch, setInsertFetch] = useState(false);
  const [showModalAdd, setShowModalAdd] = useState(false);
  const [showModalEdit, setShowModalEdit] = useState(false);
  const [currentData, setCurrentData] = useState({});

  const pelatihan = useSelector(pelatihanTransaksiSelector);

  useEffect(() => {
    let formData = {
      start: start,
      count: count,
      search: "",
    };
    mutation.mutate(formData);
  }, []);

  useEffect(() => {
    if (showModalEdit && !showModalAdd) {
      setShowModalAdd(showModalEdit);
      const initValues = {
        Nik: currentData.Nik,
        TopikPelatihan: currentData.TopikPelatihan,
        JenisPelatihan: currentData.JenisPelatihan,
        LembagaPelatihan: currentData.LembagaPelatihan,
        MateriPelatihan: currentData.MateriPelatihan,
        TujuanPelatihan: currentData.TujuanPelatihan,
        TanggalPelaksanaan: currentData.TanggalPelaksanaan,
        TanggalSelesai: currentData.TanggalSelesai,
        TempatPelaksanaan: currentData.TempatPelaksanaan,
        BiayaPelatihan: currentData.BiayaPelatihan,
        Tiket: currentData.Tiket,
      };
      editHandler(initValues);
      setTanggalPelaksanaan(new Date(currentData.TanggalPelaksanaan));
      setTanggalSelesai(new Date(currentData.TanggalSelesai));
    }

    if (search !== "" && pelatihan.isGetSuccess && !pelatihan.isGetFetching) {
      let calc = pelatihan?.count - 1;
      if (calc === 0) {
        calc = 1;
      }

      if (calc % count === 0) {
        calc = calc + 1;
      }
      let tempMaxPage = pelatihan.data ? Math.ceil(calc / count) : 1;
      setSearchFetch(false);
      setMaxPage(tempMaxPage);
    } else if (
      search === "" &&
      pelatihan.isGetSuccess &&
      !pelatihan.isGetFetching
    ) {
      let calc = pelatihan?.count - 1;
      if (calc === 0) {
        calc = 1;
      }

      if (calc % count === 0) {
        calc = calc + 1;
      }
      let tempMaxPage = pelatihan.data ? Math.ceil(calc / count) : 1;
      setSearchFetch(false);
      setMaxPage(tempMaxPage);
    }

    if (pelatihan.isGetSuccess && maxPage === 0 && firstLoading === false) {
      let calc = pelatihan?.count - 1;
      if (calc === 0) {
        calc = 1;
      }

      if (calc % count === 0) {
        calc = calc + 1;
      }
      let tempMaxPage = pelatihan.data ? Math.ceil(calc / count) : 1;
      setMaxPage(tempMaxPage);
      setFirstLoading(true);

      mutation.mutate({
        start: start,
        count: count,
        search: search,
      });
    }

    if (insertFetch) {
      setInsertFetch(false);
      if (pelatihan.isGetSuccess) {
        alertService.success(pelatihan.message, {
          autoClose: true,
          keepAfterRouteChange: false,
        });
        mutation.mutate({
          start: start,
          count: count,
          search: search,
        });
      }
    }

    if (updateFetch) {
      setUpdateFetch(false);
      if (pelatihan.isUpdateSuccess) {
        alertService.success(pelatihan.message, {
          autoClose: true,
          keepAfterRouteChange: false,
        });
        mutation.mutate({
          start: start,
          count: count,
          search: search,
        });
      }
    }
  });

  function handleSearch(searchValue) {
    let formData = {
      start: 0,
      count: 5,
      search: searchValue,
    };
    mutation.mutate(formData);

    setStart(0);
    setCount(5);
    setSearch(searchValue);
    setSearchFetch(true);
  }

  function handleUpdatePage(newPage) {
    let newStart = newPage * count - count;

    let formData = {
      start: newStart,
      count: count,
      search: search,
    };
    mutation.mutate(formData);

    setPage(newPage);
    setStart(newStart);
  }

  const reapprove = () => {
    let formData = {
      start: start,
      count: count,
      search: search,
    };
    mutation.mutate(formData);
  };

  function handleUpdateCount(newCount) {
    let calc = pelatihan.count - 1;
    if (calc === 0) {
      calc = 1;
    }

    let params = {
      start: newCount === "-1" ? 0 : start,
      count: newCount === "-1" ? pelatihan.count : newCount,
      search: search,
    };
    mutation.mutate(params);

    setPage(1);
    setCount(newCount === "-1" ? pelatihan.count : newCount);
    setStart(newCount === "-1" ? 0 : start);
    setMaxPage(newCount === "-1" ? 1 : Math.ceil(calc / newCount));
  }

  function handleCurrentData(values) {
    setCurrentData(values);
  }

  function handleModal(status) {
    setShowModalAdd(status.showModalAdd);
    setShowModalEdit(status.showModalEdit);

    dispatch(getMinKaryawan({ search: "" }));
  }

  let lamaPelatihan = 0;
  let statusLamaPelatihan = true;
  if (TanggalPelaksanaan !== "" && TanggalSelesai !== "") {
    Math.round(
      (TanggalSelesai.getTime() - TanggalPelaksanaan.getTime()) /
        (1000 * 60 * 60 * 24)
    );
  }

  return (
    <>
      <div className="md:ml-64">
        <div
          style={{ background: Colors.primary }}
          className="pt-14 pb-16 px-3 md:px-8 h-auto"
        >
          <div className="container mx-auto max-w-full">
            <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
          </div>
        </div>

        <div className="px-3 md:px-8 h-auto -mt-32">
          <div className="container mx-auto max-w-full">
            <div className="grid grid-cols-1 px-4">
              <TableCard
                usingMutation={true}
                mutation={mutation}
                primaryID="TPelatihanID"
                transaksi={true}
                handleSearch={handleSearch}
                searchPlaceholder="Pelatihan"
                updatePage={handleUpdatePage}
                updateCount={handleUpdateCount}
                currentData={handleCurrentData}
                currentPage={page}
                maxPage={maxPage}
                tableTitle="Master Pelatihan"
                tableData={mutation.data}
                colOneTitle="ID"
                colOneData="TPelatihanID"
                colTwoTitle="Nama Karyawan"
                colTwoData="NamaKaryawan"
                colThreeTitle="Keterangan"
                colThreeData="JenisPelatihanKet"
                colFourTitle="Topik Pelatihan"
                colFourData="TopikPelatihan"
                colFiveTitle="Tanggal"
                colFiveData="TanggalMonitoring"
                colSevenTitle="Status Approval"
                colSevenData="StatusKet"
                fetching={pelatihan.isGetFetching}
                modal={handleModal}
                reapprove={reapprove}
                //   editEnabled={true}
                hrd={true}
              />
            </div>
          </div>
        </div>
      </div>
      <Modal
        size="regular"
        active={showModalAdd}
        toggler={() => {
          setShowModalAdd(true);
        }}
      >
        <ModalHeader
          className="mt-20"
          toggler={() => {
            setTanggalPelaksanaan("");
            setTanggalSelesai("");
            setShowModalAdd(false);
            setShowModalEdit(false);
            setButtonTouched(false);
            clearHandler();
          }}
        >
          {showModalEdit ? "Edit Data" : "Tambah Data"}
        </ModalHeader>
        <ModalBody>
          <form className="w-full max-w-lg" onSubmit={submitHandler}>
            <KaryawanSelectorBuilder
              value={values.Nik}
              onChange={customHandler}
              noTlpn={true}
            />
            <div className="flex flex-wrap -mx-3 mb-6">
              <div className="w-full md:w-1/2 px-3 md:mb-0 mb-6">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                  Jenis Pelatihan
                </label>
                <div className="inline-block relative w-full  ">
                  <select
                    value={values.JenisPelatihan}
                    onChange={changeHandler}
                    name="JenisPelatihan"
                    className={
                      (touched.JenisPelatihan || buttonTouched) &&
                      errors.JenisPelatihan
                        ? "block appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                        : "block appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                    }
                  >
                    <option defaultValue disabled value={-1} hidden>
                      -- Pilih Data --
                    </option>
                    <option value={1}>Internal</option>
                    <option value={2}>Eksternal</option>
                    <option value={3}>MDP</option>
                  </select>
                  <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                    <svg
                      className="fill-current h-4 w-4"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                    >
                      <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                    </svg>
                  </div>
                  {(touched.JenisPelatihan || buttonTouched) &&
                    errors.JenisPelatihan && (
                      <p className="text-red-500 text-xs italic">
                        {errors.JenisPelatihan}
                      </p>
                    )}
                </div>
              </div>
              <div className="w-full md:w-1/2 px-3 md:mb-0">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                  Topik Pelatihan
                </label>
                <input
                  value={values.TopikPelatihan}
                  onChange={changeHandler}
                  name="TopikPelatihan"
                  className={
                    (touched.TopikPelatihan || buttonTouched) &&
                    errors.TopikPelatihan
                      ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                      : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                  }
                  type="text"
                />
                {(touched.TopikPelatihan || buttonTouched) &&
                  errors.TopikPelatihan && (
                    <p className="text-red-500 text-xs italic">
                      {errors.TopikPelatihan}
                    </p>
                  )}
              </div>
            </div>

            <div className="flex flex-wrap -mx-3 mb-6">
              <div className="w-full md:w-1/2 px-3 md:mb-0">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                  Materi Pelatihan *
                </label>
                <input
                  value={values.MateriPelatihan}
                  onChange={changeHandler}
                  name="MateriPelatihan"
                  className={
                    (touched.MateriPelatihan || buttonTouched) &&
                    errors.MateriPelatihan
                      ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                      : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                  }
                  type="text"
                />
                {(touched.MateriPelatihan || buttonTouched) &&
                  errors.MateriPelatihan && (
                    <p className="text-red-500 text-xs italic">
                      {errors.MateriPelatihan}
                    </p>
                  )}
              </div>

              <div className="w-full md:w-1/2 px-3 md:mb-0">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                  Lembaga Pelatihan
                </label>
                <input
                  value={values.LembagaPelatihan}
                  onChange={changeHandler}
                  name="LembagaPelatihan"
                  className={
                    (touched.LembagaPelatihan || buttonTouched) &&
                    errors.LembagaPelatihan
                      ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                      : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                  }
                  type="text"
                />
                {(touched.LembagaPelatihan || buttonTouched) &&
                  errors.LembagaPelatihan && (
                    <p className="text-red-500 text-xs italic">
                      {errors.LembagaPelatihan}
                    </p>
                  )}
              </div>
            </div>
            <div className="flex flex-wrap -mx-3 mb-6">
              <div className="w-full md:w-1/2 px-3 md:mb-0 mb-6">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                  Tujuan Pelatihan
                </label>
                <input
                  value={values.TujuanPelatihan}
                  onChange={changeHandler}
                  name="TujuanPelatihan"
                  className={
                    (touched.TujuanPelatihan || buttonTouched) &&
                    errors.TujuanPelatihan
                      ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                      : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                  }
                  type="text"
                />
                {(touched.TujuanPelatihan || buttonTouched) &&
                  errors.TujuanPelatihan && (
                    <p className="text-red-500 text-xs italic">
                      {errors.TujuanPelatihan}
                    </p>
                  )}
              </div>
              <div className="w-full md:w-1/2 px-3 md:mb-0">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                  Biaya Pelatihan
                </label>
                <input
                  value={values.BiayaPelatihan}
                  onChange={changeHandler}
                  name="BiayaPelatihan"
                  className={
                    (touched.BiayaPelatihan || buttonTouched) &&
                    errors.BiayaPelatihan
                      ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                      : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                  }
                  type="number"
                />
                {(touched.BiayaPelatihan || buttonTouched) &&
                  errors.BiayaPelatihan && (
                    <p className="text-red-500 text-xs italic">
                      {errors.BiayaPelatihan}
                    </p>
                  )}
              </div>
            </div>

            <div className="flex flex-wrap -mx-3">
              <div className="w-full md:w-1/2 px-3 mb-6">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                  Tanggal Pelaksanaan
                </label>
                <DatePicker
                  className={
                    !isValidTanggalPelaksanaan
                      ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                      : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                  }
                  selected={TanggalPelaksanaan}
                  onChange={(date) => {
                    setTanggalPelaksanaan(date);
                    setTanggalSelesai("");
                    setIsValidTanggalPelaksanaan(true);
                    setIsValidTanggalSelesai(false);
                    if (showModalEdit) {
                      setDateChanged(true);
                    }
                  }}
                />
                {!isValidTanggalPelaksanaan && (
                  <p className="text-red-500 text-xs italic">
                    Tanggal pelaksanaan wajib diisi
                  </p>
                )}
              </div>

              <div className="w-full md:w-1/2 px-3 mb-6">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                  Tanggal Selesai
                </label>
                <DatePicker
                  className={
                    !isValidTanggalSelesai
                      ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                      : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                  }
                  disabled={TanggalPelaksanaan === ""}
                  minDate={new Date(TanggalPelaksanaan).setDate(
                    new Date(TanggalPelaksanaan).getDate()
                  )}
                  selected={TanggalSelesai}
                  onChange={(date) => {
                    setTanggalSelesai(date);
                    setIsValidTanggalSelesai(true);
                    if (showModalEdit) {
                      setDateChanged(true);
                    }
                  }}
                />
                {!isValidTanggalSelesai && (
                  <p className="text-red-500 text-xs italic">
                    Tanggal selesai wajib diisi
                  </p>
                )}
              </div>
            </div>
            <div className="flex flex-wrap -mx-3 mb-6">
              <div className="w-full md:w-1/2 px-3 md:mb-0 mb-6">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                  Tempat Pelaksanaan
                </label>
                <input
                  value={values.TempatPelaksanaan}
                  onChange={changeHandler}
                  name="TempatPelaksanaan"
                  className={
                    (touched.TempatPelaksanaan || buttonTouched) &&
                    errors.TempatPelaksanaan
                      ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                      : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                  }
                  type="text"
                />
                {(touched.TempatPelaksanaan || buttonTouched) &&
                  errors.TempatPelaksanaan && (
                    <p className="text-red-500 text-xs italic">
                      {errors.TempatPelaksanaan}
                    </p>
                  )}
              </div>

              <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                  Tiket
                </label>
                <div className="inline-block relative w-full  ">
                  <select
                    value={values.Tiket}
                    onChange={changeHandler}
                    name="Tiket"
                    // className=" appearance-none w-full bg-white border hover:border-gray-800 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
                    className={
                      "block appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                    }
                  >
                    <option value={0}>Tidak</option>
                    <option value={1}>Iya</option>
                  </select>
                  <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                    <svg
                      className="fill-current h-4 w-4"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                    >
                      <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </ModalBody>
        <ModalFooter>
          <Button
            color="red"
            buttonType="link"
            onClick={() => {
              setTanggalPelaksanaan("");
              setTanggalSelesai("");
              setShowModalAdd(false);
              setShowModalEdit(false);
              clearHandler();
            }}
            ripple="dark"
          >
            Cancel
          </Button>

          <Button
            color={
              (isValid || (showModalEdit && dateChanged && !isValid)) &&
              isValidTanggalPelaksanaan &&
              isValidTanggalSelesai
                ? "green"
                : "blueGray"
            }
            onClick={() => {
              if (!isValid && changed) {
                setButtonTouched(true);
              }
              if (TanggalPelaksanaan === "") {
                setIsValidTanggalPelaksanaan(false);
              }
              if (TanggalSelesai === "") {
                setIsValidTanggalSelesai(false);
              }
              let tempIsValid = isValid;
              if (showModalEdit && dateChanged && !isValid) {
                tempIsValid = true;
              }
              if (
                tempIsValid &&
                isValidTanggalPelaksanaan &&
                isValidTanggalSelesai
              ) {
                const tanggal = {
                  TanggalPelaksanaan: JSON.stringify(TanggalPelaksanaan),
                  TanggalSelesai: JSON.stringify(TanggalSelesai),
                  TPelatihanID: currentData.TPelatihanID,
                };
                setShowModalAdd(false);
                setShowModalEdit(false);
                if (showModalEdit) {
                  createNotification("Berhasil mengubah data", "success");

                  dispatch(
                    updatePelatihanTransaksi(Object.assign(values, tanggal))
                  );
                } else {

                  mutationInput.mutate(Object.assign(values, tanggal), {
                    onSuccess: async (data, context) => {
                      toast.success(data.message, {
                        position: "bottom-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: false,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                      });
                      setShowModalAdd(false);
                      setShowModalEdit(false);
                      mutation.mutate({
                        start: start,
                        count: count,
                        search: search,
                      });
                    },
                    onError: async (data, context) => {
                      toast.error(data.message, {
                        position: "bottom-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: false,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                      });
                    },
                  });
                }
              }
            }}
            ripple={
              isValid && isValidTanggalPelaksanaan && isValidTanggalSelesai
                ? "light"
                : ""
            }
          >
            SUBMIT
          </Button>
        </ModalFooter>
      </Modal>
      <NotificationContainer />
    </>
  );
};

export default PelatihanPage;
